exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".can-not-input[data-v-7acc1b96] input{pointer-events:none}", ""]);

// exports
